let selectBoxes = $('.gfield_select');

if(selectBoxes.length) {
    selectBoxes.each(function () {

        let selectBox = $(this),
            placeholder = selectBox.find('option:first').text();

        checkPlaceholder();

        selectBox.on('change', function () {
            checkPlaceholder();
        });

        function checkPlaceholder() {
            selectBox.toggleClass('placeholder', selectBox.val() === placeholder || selectBox.val() === '' || selectBox.val() === null);
        }

    });
}


$(document).on('gform_confirmation_loaded', function(event, form_id){
    // scroll to top of form container
    if(form_id == 1) {
        let container = $('.wp-block-pulp-contact-page'),
            h1 = container.find('h1').first();

        h1.addClass('visually-hidden-focusable');

        $('html, body').animate({
            scrollTop: container.offset().top - 150
        }, 500);
    }

    // You can add your custom actions here, like tracking a conversion
    // if (form_id === 123) { // Check for a specific form ID
    //     // Custom code for form 123
    // }
});
